@if(data.header) {
<h2 mat-dialog-title>{{ data.header }}</h2>
}
<mat-dialog-content [ngClass]="data.header ? 'mb-2' : 'mt-8'">{{ data.content }}</mat-dialog-content>
<mat-icon
  class="absolute float-right top-4 right-4 h-6 w-6 text-black cursor-pointer"
  svgIcon="x"
  [mat-dialog-close]="true"
></mat-icon>
